module.exports = __webpack_public_path__ + "img/london-cards.b768bfe3.jpg";